export default "__VITE_ASSET__$zDIXUiF__"